import axios from '../axios'

const getAvailableEventTeachersApi = async (startAt, endAt) => {
    return await axios.get(`api/available-event-teachers`, { params: { startAt, endAt } })
}

export default getAvailableEventTeachersApi
